var React = require('react');

function Profile2Path (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"profile-2","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M1443.09040043 113.20485134c-54.96651095 48.76208387-136.29139617 106.38529783-248.90957798 152.4459039-244.5 100-492.5-200-724.5-254.5C313.60809517-25.51288114 116.80478939 102.3297635 4.7046301 189.93553358"}));
}

Profile2Path.defaultProps = {"viewBox":"0 0 1447.795 290.608"};

module.exports = Profile2Path;

Profile2Path.default = Profile2Path;
